export enum DaysOfWeekValidationError {
  EmptyValue = "EMPTY_VALUE",
}
